import { Injectable } from '@angular/core';
import { Http, RequestOptions, Response, URLSearchParams, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Subject }    from 'rxjs/Subject';
import { CookieService } from 'ngx-cookie';
import { Angulartics2 } from 'angulartics2';

import { UserService } from './user.service';
import { Filter } from '../models/filter.constructor'

import { environment } from '../environment';
import { Method } from '../models/method';
import { Product } from '../models/product';
import { Currency } from '../models/currency';
import { Statistic } from '../models/statistics';
import { PaymentProduct } from '../models/paymentproduct';
import { Category } from '../models/category';
import { Order } from '../models/order';
import { Item } from '../models/item';
import { Img } from '../models/image';

declare var connectsdk: any;

@Injectable()
export class StoreService {

	keys: any;
	cart: any[];
	currency: any;
	total: number;
	customizer: any[];
	customs = new Array();
	currencySelectorEnabled: boolean;
	
	products: Product;
	items: Item;

	private messageAnnounce = new Subject<string>();

	public now: any;
	public sdk: any;
	public session: any;
	public sessionKeys: any;
	public nulledSessionTokens: any[];
	public methods: any;

	constructor(private http 	: Http,
				private cookie 	: CookieService,
				private user 	: UserService,
				private track 	: Angulartics2 ) {

		// set token if saved in local storage
		this.total = 0;
		this.cart = [];
		this.customizer = [];
		
		this.now = new Date();
		this.now.setMinutes(this.now.getMinutes() + 7200);
		
		this.session = new Date();
		this.session.setMinutes(this.session.getMinutes() + 20);

		this.currencySelectorEnabled = false;
	}

	message = this.messageAnnounce = new Subject<string>();

	announceMessage(message: string) {
		this.messageAnnounce.next(message);
	}


	
	/**
	* Get Store Products from the API
	**/

	// Get info on a single product
	get(identifiers:any): Promise<Product> {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });
		
		if ( !identifiers ) identifiers = 'all';

		this.track.eventTrack.next({ action: 'ViewContent', properties: { content_ids: identifiers, content_type:'product' }});

		return this.http
			.get(`${environment.baseUrl}/product/?productID=${identifiers}`, options)
			.toPromise()
			.then(mapProduct)
			.catch((err) => { console.log(err); })
  	}

	// Get specific products from the server
	getProducts(identifiers:any): Promise<Product> {
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });
		if ( !identifiers ) identifiers = 'all';
		
		return this.http
			.get(`${environment.baseUrl}/getproducts/?products=${identifiers}`, options)
			.toPromise()
			.then(mapProducts)
			.catch((err) => { console.log(err); } )
  	}

	// Get specific products from the server
	getCartProducts(identifiers?, gifting?): Promise<Product> {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });
		let g = gifting ? true : false;
		if ( !identifiers ) identifiers = 'all';

		return this.http
			.get(`${environment.baseUrl}/getcartproducts/?products=${identifiers}&gift=${g}`, options)
			.toPromise()
			.then(mapProducts)
			.catch((err) => { console.log(err); } )
  	}

	// Get specific products from the server
	getAllProducts(): Promise<Product> {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });

		return this.http
			.get(`${environment.baseUrl}/getproducts/`, options)
			.toPromise()
			.then(mapProducts)
			.catch((err) => { console.log(err); } )
  	}


  	// Count products
  	countProductImages(identifiers:any) {
		let data = new URLSearchParams(); 
		
		return this.http
			.post(`${environment.baseUrl}/product/images/?productID=${identifiers}`, data, {headers: this.getHeaders()})
			.toPromise()
			.then((responce) => {
				return responce.json()['images'];
			})
			.catch((err) => { console.log(err); } )
  	}


	// Count products
	hasItems(identifiers:any, products:any, item:any) {

		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });

		let data = new URLSearchParams();
		data.append( 'itemID', identifiers );
		data.append( 'productID', products );
		data.append( 'item', item );

		return this.http
			.post(`${environment.baseUrl}/hasitems/`, data, options)
			.toPromise()
			.then((responce) => {
				return responce.json();
			})
			.catch((err) => { console.log(err); } )
  	}
	
	// Count products
	ownsItems(identifiers:any) {

		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });

		let data = new URLSearchParams();
		data.append( 'item', identifiers );

		return this.http
			.post(`${environment.baseUrl}/ownsitem/`, data, options)
			.toPromise()
			.then((responce) => {
				return responce.json();
			})
			.catch((err) => { console.log(err); } )
  	}


	// Get specific products from the server
 	popularItems(): Promise<Item>{
		// let id = identifiers.join(',');
		return this.http
			.get(`${environment.baseUrl}/popular/items/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapItem)
			.catch((err) => { console.log(err); } )
  	}

	// Get specific products from the server
	popularProducts(): Promise<Product>{
		// let id = identifiers.join(',');
		return this.http
			.get(`${environment.baseUrl}/popular/products/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapProducts)
			.catch((err) => { console.log(err); } )
  	}



  	getNewCryptoAddress( coin:any ): Observable<any> {

  		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity,
			'Content-Type': 'application/json' 
		});
		
		let options = new RequestOptions({ headers: headers });

		// Create a post object for the user login
		let data = new URLSearchParams(); 
		data.append( 'coin', coin );

		return this.http
			.post(`${environment.baseUrl}/crypto/address/`, data, options )
			.map((response: Response) => {
				return response.json().address;
			});

	}


	checkCryptoAddress( address:string ) {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });

		// Create a post object for the user login
		let data = new URLSearchParams(); 
		data.append( 'address', btoa( address ) );

		return this.http
			.post(`${environment.baseUrl}/crypto/checkaddress/`, data, headers)
			.toPromise()
			.then((responce) => {
				return responce.json();
			})
			.catch((err) => { console.log(err); })

  	}


  	// Get all products from the server
	loadProducts(): Promise<Product> {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity,
			'Content-Type': 'application/json' 
		});

		let options = new RequestOptions({ headers: headers });

		return this.http
			.get(`${environment.baseUrl}/products/?all=true`, options)
			.toPromise()
      		.then(mapProducts)
      		.catch((err) => { console.log(err); } )
  	}

  	// Get all products that include a specific item
	loadProductsWithItem(itemID): Promise<Product> {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });

		return this.http
			.get(`${environment.baseUrl}/productwithitems/?item=${itemID}`, headers)
			.toPromise()
      		.then(mapProducts)
      		.catch((err) => { console.log(err); } )
  	}

	// Count products
  	countProducts(): Observable<any> {
		let data = new URLSearchParams(); 
		return this.http
			.post(`${environment.baseUrl}/products/?all=true`, data)
			.map((response: Response) => {
				return response.json()['length'];
		});
  	}

  	numberOfProductsWithItem(itemID) {
		
		let data = new URLSearchParams(); 
		data.append('item', itemID);
		
		return this.http
			.post(`${environment.baseUrl}/productwithitems/`, data, {headers: this.getHeaders()})
			.toPromise()
			.then((responce) => {
				return responce.json()['length'];
			})
			.catch((err) => { console.log(err); } )
  	}

  	// Get product categories from the database
	getCategories(): Promise<Category> {
		return this.http
			.get(`${environment.baseUrl}/categories/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapCategories)
			.catch((err) => { console.log(err); } )
	}

	// Get product categories from the database
	getUsedCategories(): Promise<Category> {
		return this.http
			.get(`${environment.baseUrl}/categories/used/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapCategories)
			.catch((err) => { console.log(err); } )
	}

	// Get product categories from the database
	getActiveCategories(): Promise<Category> {
		return this.http
			.get(`${environment.baseUrl}/categories/used/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapCategories)
			.catch((err) => { console.log(err); } )
	}

	// Get product categories from the database
	getParentCategories(): Promise<Category> {
		return this.http
			.get(`${environment.baseUrl}/parentcategories/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapCategories)
			.catch((err) => { console.log(err); } )
	}

	// Count product categories from the database
	countParentCategories(): Observable<any> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.user.token });
		let options = new RequestOptions({ headers: headers });

		return this.http
			.post(`${environment.baseUrl}/parentcategories/`, options)
			.map((response: Response) => {
				return response.json().count;
		});

	}

	// Get product categories from the database
	getGroups(): Promise<Category> {
		return this.http
			.get(`${environment.baseUrl}/itemgroups/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapCategories)
			.catch((err) => { console.log(err); } )
	}

	getOrder(): Promise<Order> {
		return this.http
			.get(`${environment.baseUrl}/order/`, {headers: this.getHeaders()})
			.toPromise()
			.then(mapOrders)
			.catch((err) => { console.log(err); } )	
	}


	/**
	* Purchase Functions
	**/ 


	// Fetch info for cart items
	purchaseData() {
		let items = this.getCartContents();
		// Request data on valid payment methods for this account.
		Promise.resolve( this.getProducts(items) ).then((data) => {
			return data;
		});
	}


	cartHasItem( passportID ) {

		var hasItem = false;

		let items = this.cookie.get('items');
		if (items) {
			let cartData = JSON.parse(items);
			for (var i = cartData.length - 1; i >= 0; i--) {
				if ( passportID == cartData[i] ) {
					hasItem = true;
				}
			}
		}

		return hasItem;
	}


	// Send a Credit Card purchase
	purchaseItems(method, credit?, gift?): Promise<Order> {

		let identity = this.cookie.get('id');

		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity
		});

		/* Get the order items in the cart*/
		let items = this.getCartContents();
		let cartitems = JSON.stringify(items);

		items = this.getCustomizerContents();
		let customitems = JSON.stringify(items);
		
		let lastCurrency = this.cookie.get('currency');
		this.currency = lastCurrency ? lastCurrency : 'USD';

		credit = JSON.stringify(credit);

		// Create a post object for the user login
		let data = new URLSearchParams(); 
		data.append('credit', btoa(credit));
		data.append('method', method);
		data.append('products', cartitems);
		data.append('items', customitems);
		data.append('currency', this.currency);
		data.append('gift', gift);

		// Pass them to purchase endpoint
		return this.http
			.post(`${environment.baseUrl}/purchase/`, data, { headers: headers })
			.toPromise()
			.then(mapOrders)
			.catch((err) => { console.log(err); } );
		
	}

	// Add account funds with a credit card
	addFunds(amount, method, credit?): Promise<Order> {

		let identity = this.cookie.get('id');
		credit = JSON.stringify(credit);

		// Create a post object for the user login
		let data = new URLSearchParams();
		data.append('credit', btoa(credit));
		data.append('method', method);
		data.append('amount', amount);

		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity
		});
	
		this.track.eventTrack.next({ action: 'AddPaymentInfo' });

		// Pass them to purchase endpoint
		return this.http
			.post(`${environment.baseUrl}/purchase/`, data, { headers: headers })
			.toPromise()
			.then(mapOrder)
			.catch((err) => { console.log(err); } );
	}


	// Get all available payment methods from the database
	getPaymentMethods(total?): Promise<Method> {
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		if (identity) {
			
			let headers = new Headers({
				'Authorization': 'Bearer ' + identity,
				'Content-Type': 'application/json' 
			});

			let options = new RequestOptions({ headers: headers });

			// Pass them to purchase endpoint
			return this.http
				.get(`${environment.baseUrl}/cart/?total=${total}`, options)
				.toPromise()
				.then(mapMethods)
				.catch((err) => { console.log(err); } )
		}
	}

	/**
	* PayPal's integrated checkout (return)
	**/

	paypalCheckout(total, checkout?, actions?, cart?): Promise<Order> {

		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.user.token });
		let options = new RequestOptions({ headers: headers });

		let items = this.getCartContents();
		let products = cart ? JSON.stringify(items) : '';

		items = this.getCustomizerContents();
		let customitems = JSON.stringify(items);

		let data = new URLSearchParams();
		data.append('method', 'paypal');
		data.append('success', 'true');
		data.append('products', products);
		data.append('items', customitems);
		data.append('payerID', checkout.payerID);
		data.append('paymentID', checkout.paymentID);
		data.append('paymentToken', checkout.paymentToken);
		data.append('returnUrl', checkout.returnUrl);
		data.append('amount', total);

		return this.http
			.post(`${environment.baseUrl}/purchase/`, data, options)
			.toPromise()
			.then(mapOrder)
			.catch((err) => { console.log(err); } )
	}

	/**
	* PayPal Hosted Checkout
	**/

	paypalHostedCheckout(total?, gift?): Promise<any> {

		let identity = this.cookie.get('id');

		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.user.token });
		let options = new RequestOptions({ headers: headers });

		let items = this.getCartContents();
		let cartitems = JSON.stringify(items);

		let customs = this.getCustomizerContents();
		let customitems = JSON.stringify(customs);

		let data = new URLSearchParams();
		
		if ( !total ) {
			data.append('products', cartitems);
			data.append('items', customitems)
		} else {
			data.append('amount', total);	
		}

		data.append('gift', gift);

		return this.http
			.post(`${environment.baseUrl}/paypal/`, data, options)
			.toPromise()
			.then((response) => {
				let resp = response.json().url;
				return resp;
			}).catch((err) => { 
				// toss, no user
			});
	}


	/**
	* PayPal Check Hosted Checkout Outcome
	**/

	checkPayPalHosted(): Promise<any> {
				
		let identity = this.cookie.get('id');

		// Authorize a user with JWT headers before purchasing...
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.user.token });
		let options = new RequestOptions({ headers: headers });

		// Pass them to purchase endpoint
		return this.http
			.post(`${environment.baseUrl}/paypal/check/`, null, options)
			.toPromise()
			.then((response) => {
				let resp = response.json().order;
				return resp;
			})
			.catch((err) => { 
				// toss, no data
			});

	}



	// Get items purchased by a user
	getPurchasedProducts(username?): Promise<Product> {

		// Authorize a user with JWT headers if no user is defined
		let options;
		if ( !username ) {
			let headers = new Headers({ 'Authorization': 'Bearer ' + this.user.token });
			options = new RequestOptions({ headers: headers });
		} else {
			options = new RequestOptions({ headers: null });
		}

		let data = new URLSearchParams();
		data.append('username', username);

		return this.http
			.post(`${environment.baseUrl}/purchased/`, data, options)
			.toPromise()
			.then(mapProducts)
			.catch((err) => { console.log(err); } )
	}


	// Get items purchased by a user
	getPurchasedProductsCount(username?): Promise<any> {
		// Authorize a user with JWT headers if no user is defined
		let options;
		if ( !username ) {
			let headers = new Headers({ 'Authorization': 'Bearer ' + this.user.token });
			options = new RequestOptions({ headers: headers });
		} else {
			options = new RequestOptions({ headers: null });
		}

		let data = new URLSearchParams();
		data.append('username', username);

		return this.http
			.post(`${environment.baseUrl}/purchased/`, data, options)
			.toPromise()
			.then((responce) => {
				return responce.json()['count'];
			})
			.catch((err) => { console.log(err); } )
	}

	
	// Get items purchased by a user
	countPurchasedProductsCount(): Promise<any> {
		// Add authorization header with jwt token
		let headers = new Headers({ 'Authorization': 'Bearer ' + this.user.token });
		let options = new RequestOptions({ headers: headers });

		return this.http
			.post(`${environment.baseUrl}/purchased/items/`, options)
			.toPromise()
			.then((responce) => {
				return responce.json()['count'];
			})
			.catch((err) => { console.log(err); } )
	}


	// Get items purchased by a user
	getPurchasedItems(username?): Promise<Item> {
		// Authorize a user with JWT headers if no user is defined
		let options = new RequestOptions({ headers: null });
		if ( !username ) {
			let identity = this.cookie.get('id');
			let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
			options = new RequestOptions({ headers: headers });
		}

		let data = new URLSearchParams();
		data.append('username', username);

		return this.http
			.post(`${environment.baseUrl}/purchased/items/`, data, options)
			.toPromise()
			.then(mapItem)
			.catch((err) => { console.log(err); } )
	}


	// Count products
  	countPurchasedItems(username?): Promise<any> {

		// Authorize a user with JWT headers if no user is defined
		let options = new RequestOptions({ headers: null });
		if ( !username ) {
			let identity = this.cookie.get('id');
			let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
			options = new RequestOptions({ headers: headers });
		}

		let data = new URLSearchParams(); 
		data.append('username', username);

		return this.http
			.post(`${environment.baseUrl}/purchased/items/`, data, options)
			.toPromise()
			.then((responce) => {
				return responce.json()['count'];
			})
			.catch((err) => { console.log(err); } )
  	}

	/**
	* Gift handler
	**/

	checkKeyProducts(key): Promise<Product> {
		let data = new URLSearchParams();
		data.append('key', key);

		return this.http
			.post(`${environment.baseUrl}/checkgift/products/`, data)
			.toPromise()
			.then(mapProducts)
			.catch((err) => { 
				//
			})
	}

	checkKeyItems(key): Promise<Item> {
		let data = new URLSearchParams();
		data.append('key', key);

		return this.http
			.post(`${environment.baseUrl}/checkgift/items/`, data)
			.toPromise()
			.then(mapItem)
			.catch((err) => { 
				//
			})
	}

	addGiftToAccount(key): Promise<Order> {

		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let data = new URLSearchParams();
		data.append('key', key);

		return this.http
			.post(`${environment.baseUrl}/addgift/`, data, { headers: headers })
			.toPromise()
			.then(mapOrder)
			.catch((err) => { console.log(err); } )

	}

	sendGift(user, items?, type?): Promise<Order> {
		let data = new URLSearchParams();
		data.append('items', btoa(items));
		data.append('user', btoa(user));
		data.append('type', type);

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity
		});

		return this.http
			.post(`${environment.baseUrl}/sendgift/`, data, { headers: headers })
			.toPromise()
			.then(mapOrder)
			.catch((err) => { console.log(err); } )
	}





	/**
	* Cart cookie handler
	**/

	getContents() {
		let products = this.cookie.get('cart');
  		if (products) {
  			Promise.resolve( this.getProducts(JSON.parse(products)) ).then((p) => {
				this.products = p;
			});
  		}

  		let items = this.cookie.get('items');
		if ( items ) {
			let query = new Filter();
			query.ids = items;
			Promise.resolve( this.getItems(query) ).then( (i) => {
				this.items = i;
			});
		}
  		return [this.products, this.items];
	}

  	getCartContents() {
  		let cartman = this.cookie.get('cart');
  		if (cartman) this.cart = JSON.parse(cartman);
  		return this.cart;
  	}

  	getCartItemIDs() {

  		let cproduct = this.cookie.get('cart');
  		let xitem = this.cookie.get('items');

  		if (cproduct || xitem ) {

  			if ( cproduct ) cproduct = JSON.parse(cproduct);
			if ( xitem ) xitem = JSON.parse(xitem);

	  		// if (cproduct.length > 0 || xitem.length > 0 ) {

				let identity = this.cookie.get('id');
				let headers = new Headers({ 'Authorization': 'Bearer ' + identity });

				let data = new URLSearchParams();
				if ( cproduct ) data.append('cart', cproduct);
				if ( xitem ) data.append('items', xitem);

				return this.http
					.post(`${environment.baseUrl}/itemincart/`, data, { headers: headers })
					.toPromise()
					.then( (response) => {
						return response.json().items;
					})
					.catch((err) => { 
						// toss, no data
					});
	  		// }
	  	}
  	}

  	getItemContents() {
  		let items = this.cookie.get('items');
  		if (items) this.customs = JSON.parse(items);
  		return this.customs;
  	}

  	getCustomizerContents() {
  		let cartman = this.cookie.get('items');
  		
  		if (cartman) {
  			this.customizer = JSON.parse(cartman);	
  		} else { this.customizer = []; }

  		return this.customizer;
  	}

	ownedHidden() {
		let showhidden = this.cookie.get('hideOwned');
		return (showhidden) ? true : false;
	}

	showOwned(hide) {
  		this.cookie.put('hideOwned', hide, { expires: this.now });
		return hide;
	}

  	countCartContents() {
  		let items = this.cookie.get('items');
  		let cartman = this.cookie.get('cart');
  		let numberOfItems = 0;
  		if( items ) numberOfItems = JSON.parse(items).length;
  		if( cartman ) numberOfItems = numberOfItems + JSON.parse(cartman).length;
  		return numberOfItems;
  	}


  	/**
  	 *	Set Cart Products
	**/
	
	setCartContents(productIdentifiers) {
  		this.cart = productIdentifiers;
  		this.cookie.put('cart', JSON.stringify( this.cart ), { expires: this.now });
  		return this.cart;
  	}

	setItemContents(itemIdentifiers) {
		this.customs = itemIdentifiers;
  		this.cookie.put('items', JSON.stringify( this.customs ), { expires: this.now });
  		return this.customs;
  	}

	setGiftUser(user) {
		let data = new URLSearchParams();
		if ( user ) data.append('user', user);
		return this.http
			.post(`${environment.baseUrl}/checkgiftuser/`, data)
			.toPromise()
			.then( (response) => {
				let result = response.json().gift;
				if ( result == true ) {
					this.cookie.put('gift', user, { expires: this.now });
					return user;
				} else { 
					return false;
				}
			}).catch((err) => { 
				return false;
			});
  	}

  	getGiftUser() {
  		let user = this.cookie.get('gift');
  		return user;
  	}

  	removeGiftUser() { 
  		this.cookie.remove('gift'); 
		return null;
	}

	cartRequiresShipping(r) {
		// Expects comma-seperated list
		
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity,
			'Content-Type': 'application/json' 
		});

		let options = new RequestOptions({ headers: headers });

		let p = this.getCartContents();
		let i = this.getCustomizerContents();

		return this.http
			.get(`${environment.baseUrl}/carttotal/?products=${p}&items=${i}&required=${r}`, options)
			.toPromise()
			.then((responce) => {
				return responce.json();
			})
			.catch((err) => { console.log(err); } )
  	}


  	addToCart(productIdentifier: number) {
  		if ( !this.inCart( productIdentifier, null ) ) {
			this.cart.push(productIdentifier);
			this.announceMessage('Added to cart...');
			this.cookie.put('cart', JSON.stringify( this.cart ), { expires: this.now });
			this.track.eventTrack.next({ action: 'AddToCart', properties: { content_ids: productIdentifier, content_type:'product' }});
		}
  	}

  	removeFromCart(productIdentifier: number) {

  		// Find index of product ID
  		let id = this.cart.indexOf(productIdentifier);

  		// Save cart
  		this.cart.splice( id, 1 );
  		
  		this.cookie.remove('cart');
  		this.cookie.put('cart', JSON.stringify( this.cart ), { expires: this.now });

  		let count = 0;
  		for( let prop of this.cart ) {
  			if ( prop == productIdentifier ) count++;
  		}

  		return count;
  	}

  	removeItem(itemIdentifier: number) {
  		// Find index of product ID
  		let id = this.customizer.indexOf(itemIdentifier);

  		// Save customizer
  		this.customizer.splice( id, 1 );
  		
  		this.cookie.remove('items');
  		this.cookie.put('items', JSON.stringify( this.customizer ), { expires: this.now });

  		let count = 0;
  		for( let item of this.customizer ) {
  			if ( item == itemIdentifier ) count++;
  		}

  		return count;
  	}

	addItem(itemIdentifier: any) {
		if ( !this.inCart( null, itemIdentifier  ) ) {
			this.getCustomizerContents();
			this.customizer.push( itemIdentifier );
			this.cookie.put('items', JSON.stringify( this.customizer ), { expires: this.now });
			this.announceMessage('Added to cart...');
			this.track.eventTrack.next({ action: 'AddToCart', properties: { content_ids: itemIdentifier, content_type:'item' }});
		}
	}


	inCart(productID?, itemID?) {

		let result = false;
		let cart = this.cookie.get('cart');
		let items = this.cookie.get('items');

		if ( cart ) cart = JSON.parse( cart ); 
		if ( items ) items = JSON.parse( items ); 

		if ( cart && productID && cart.indexOf( productID ) > -1 ) result = true;
		if ( items && itemID && items.indexOf( itemID ) > -1 ) result = true;

		return result;
  	}


  	/*  Product quantity management */

	addQuantity(productIdentifier: number) {
  		this.addToCart(productIdentifier);
  	}

  	subtractQuantity(productIdentifier: number) {
  		this.removeFromCart(productIdentifier);
  	}

  	changeQuantity(productIdentifier: number, newQuantity: number) {
  		
  		let count = 0;
  		for( let item of this.cart ) {
  			if ( item == productIdentifier ) count++;
  		}
  		
  		if ( count > newQuantity ) {
  			for( var i = 0; i < count-newQuantity; i++ ) {
  				this.removeFromCart(productIdentifier);
  			}
  		}

  		if ( count < newQuantity ) {
  			for( var i = 0; i < newQuantity-count; i++ ) {
  				this.addToCart(productIdentifier);
  			}
  		}

  		return newQuantity;
  	}



  	/*  Item quantity management */

  	addItemQuantity(itemIdentifier: number) {
  		this.addItem(itemIdentifier);
  	}

  	subtractItemQuantity(itemIdentifier: number) {
  		this.removeItem(itemIdentifier);
  	}

  	changeItemQuantity(itemIdentifier: number, newQuantity: number) {
  		
  		let count = 0;
  		for( let item of this.customizer ) {
  			if ( item == itemIdentifier ) count++;
  		}
  		
  		if ( count > newQuantity ) {
  			for( var i = 0; i < count-newQuantity; i++ ) {
  				this.removeItem(itemIdentifier);
  			}
  		}

  		if ( count < newQuantity ) {
  			for( var i = 0; i < newQuantity-count; i++ ) {
  				this.addItem(itemIdentifier);
  			}
  		}

  		return newQuantity;
  	}



  	cartCount(productIdentifier: number) {
  		
  		let count = 0;
  		for( let item of this.cart ) {
  			if ( item == productIdentifier ) count++;
  		}

  		return count;
  	}


	
	/**
	* Currencies
	**/
	getCurrencies(): Promise<Currency> {
		return this.http
			.get(`${environment.baseUrl}/currencies/`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapCurrencies)
			.catch((err) => { console.log(err); } )
	}

	getCurrency(c?): Promise<Currency> {
		let lastCurrency = this.cookie.get('currency');
		c = c ? c : lastCurrency ? lastCurrency : 'USD';
		return this.http
			.get(`${environment.baseUrl}/currency/?x=${c}`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapCurrencies)
			.catch((err) => { console.log(err); } )
	}

  	changeCurrency(c) {
		this.cookie.put('currency', c.symbol, { expires: this.now });
	}

	enableCurrencySelector() {
		return this.currencySelectorEnabled;
	}

	/**
	* Cart cookie handler
	**/

 	clearCustomizer() {
		this.customizer = [];
		this.cookie.remove('items');
	}

	getCustomizerTotal(ids?) {
		// Expects comma-seperated list
		
		ids = ids ? ids : this.getCustomizerContents();

		return this.http
			.get(`${environment.baseUrl}/totalitems/?items=${ids}`,
			{headers: this.getHeaders()})
			.toPromise()
			.then((responce) => {
				return responce.json().total;
			})
			.catch((err) => { console.log(err); } )
  	}


  	// Clear Cart
  	clearCart() {
		this.cart = [];
		this.customizer = [];
		this.cookie.remove('cart');
		this.cookie.remove('items');
	}


	/**
	* Accept return API headers
	**/

	getCartTotal(r?, g?) {
		
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity,
			'Content-Type': 'application/json' 
		});

		let options = new RequestOptions({ headers: headers });

		let p = this.getCartContents();
		let i = this.getCustomizerContents();

		return this.http
			.get(`${environment.baseUrl}/carttotal/?products=${p}&items=${i}&required=${r}&gift=${g}`, options)
			.toPromise()
			.then((responce) => {
				return responce.json();
			})
			.catch((err) => { console.log(err); } )
  	}

  


  	 // Get specific products from the server
	getSpecificItems(identifiers:any): Promise<Item> {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity,
			'Content-Type': 'application/json' 
		});

		let options = new RequestOptions({ headers: headers });

		if ( identifiers ) {
			return this.http
				.get(`${environment.baseUrl}/getiteminfo/?items=${identifiers}`, options)
				.toPromise()
				.then(mapItem)
				.catch((err) => { console.log(err); } )
		} else {
			return null;
		}
  	}



	/**
	* Get Items
	**/

  	getItems(query?): Promise<Item> {

		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });

		// Expects comma-seperated list
		//ids?, page?, count?, sort?, cat?
		let data = new URLSearchParams();
		data.append('items', (query && query.ids) ? query.ids : 'all');
		data.append('page', (query && query.page) ? query.page : 1);
		data.append('count', (query && query.count) ? query.count : 6);
		data.append('filter', (query && query.filter) ? query.filter : '');
		data.append('sort', (query && query.sort) ? query.sort : '');
		data.append('cat', (query && query.category) ? query.category : '');
		data.append('hidden', (query && query.hidden) ? query.hidden : '');

		return this.http
			.post(`${environment.baseUrl}/getitems/`, data, options)
			.toPromise()
			.then(mapItem)
			.catch((err) => { console.log(err); })
  	}

  	


 
  	// Count products
  	countItems(query?) {

  		// 
		let identity = this.cookie.get('id');
		let headers = new Headers({ 'Authorization': 'Bearer ' + identity });
		let options = new RequestOptions({ headers: headers });

  		// Expects comma-seperated list
		//ids?, page?, count?, sort?, cat?
		let data = new URLSearchParams();
		data.append('items', (query && query.ids) ? query.ids : 'all');
		data.append('page', (query && query.page) ? query.page : 1);
		data.append('count', (query && query.count) ? query.count : 6);
		data.append('filter', (query && query.filter) ? query.filter : '');
		data.append('sort', (query && query.sort) ? query.sort : '');
		data.append('cat', (query && query.category) ? query.category : '');
		data.append('hidden', (query && query.hidden) ? query.hidden : '');

		return this.http
			.post(`${environment.baseUrl}/getitems/`, data, options)
			.toPromise()
			.then((responce) => {
				return responce.json()['count'];
			})
			.catch((err) => { console.log(err); } )
  	}


	// Count products
  	countItemsInAccount(itemIds?, productIds?) {

		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity
		});
		
		let options = new RequestOptions({ headers: headers });

  		// Expects comma-seperated list
		//ids?, page?, count?, sort?, cat?
		let data = new URLSearchParams();
		data.append('itemid', itemIds);
		data.append('productid', productIds);

		return this.http
			.post(`${environment.baseUrl}/countitems/`, data, options)
			.toPromise()
			.then((responce) => {
				return responce.json()['count'];
			})
			.catch((err) => { console.log(err); } )
  	}

  	checkCartForItem( itemID ) {

  		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity
		});
		
		let items = this.getCartContents();
		let cartitems = JSON.stringify(items);

		let options = new RequestOptions({ headers: headers });

  		// Expects comma-seperated list
		let data = new URLSearchParams();
		data.append( 'item', itemID );
		data.append( 'cart', cartitems );

		return this.http
			.post(`${environment.baseUrl}/itemincart/`, data, options)
			.toPromise()
			.then((responce) => {
				return responce.json();
			})
			.catch((err) => { console.log(err); } )
  	}



	// Search Items
  	searchItems(query?, page?): Promise <Item> {
  		
		// Authorize a user with JWT headers before purchasing...
		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity
		});

		let data = new URLSearchParams();
		data.append('query', query.filter);
		data.append('page', page ? page : 0);

		return this.http
			.post(`${environment.baseUrl}/item/search/`, data, { headers: headers })
			.toPromise()
			.then(mapItem)
  	}



  	totalItems(ids?) {
  		// Expects comma-seperated list
		return this.http
			.get(`${environment.baseUrl}/totalitems/?items=${ids}`,
			{headers: this.getHeaders()})
			.toPromise()
			.catch((err) => { console.log(err); } )
  	}

	
  

  	getItemsWithProducts() {
  		// Gets only items that are bundled with a product
		return this.http
			.get(`${environment.baseUrl}/activeitems/`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapItem)
  	}


  	// Return payment products
	getPaymentProducts( amount, currency, country?, locale? ): Promise<PaymentProduct> {

		country = country ? country : "US";
		locale = locale ? locale : "en_US";

		let details = {
			"clientSessionID": this.sessionKeys.clientSessionId,
			"customerId": this.sessionKeys.customerId,
			"invalidTokens": this.nulledSessionTokens,
			"region": this.sessionKeys.region,
			"assetUrl": environment.globalcollect.assetUrl,
			"clientApiUrl": environment.globalcollect.clientApiUrl,
			"environment": environment.globalcollect.environment
		}

		var PaymentDetails = {
			"totalAmount": amount,
			"currency": currency,
			"countryCode": country,
			"isRecurring": false,
			"locale": locale
		};

		var session = new connectsdk.Session(details);
		return session.getBasicPaymentProducts(PaymentDetails)
			.then(mapPaymentProduct)
			.catch((err) => { console.log(err); } );
  	}


	// Encrypt Purchase and Credit Card data prior to sending them out
	paymentRequest( credit, paymentDetails ): Promise<any> {

		let paymentProductInfo,
			sessionDetails = {
				"clientSessionID": this.sessionKeys.clientSessionId,
				"customerId": this.sessionKeys.customerId,
				"region": this.sessionKeys.region,
				"invalidTokens": this.nulledSessionTokens,
				"assetUrl": environment.globalcollect.assetUrl,
				"clientApiUrl": environment.globalcollect.clientApiUrl,
				"environment": environment.globalcollect.environment
			};

		var session = new connectsdk.Session(sessionDetails);
		return session.getPaymentProduct(credit.paymentProductId, paymentDetails).then( function ( product ) {
			return product.json;
		}, function () {
		    console.log('Ingenico Error');
		});

	}

	// Encrypt Purchase and Credit Card data prior to sending them out
	encryptData( credit, paymentProduct ): Promise<any> {
		
		var sessionDetails = {
				"clientSessionID": this.sessionKeys.clientSessionId,
				"customerId": this.sessionKeys.customerId,
				"region": this.sessionKeys.region,
				"invalidTokens": this.nulledSessionTokens,
				"assetUrl": environment.globalcollect.assetUrl,
				"clientApiUrl": environment.globalcollect.clientApiUrl,
				"environment": environment.globalcollect.environment
			};

		var session = new connectsdk.Session(sessionDetails);
		var req = session.getPaymentRequest();
			req.setPaymentProduct(				paymentProduct			);
			req.setValue("cardholderName", 		credit.cardholderName	);
			req.setValue("cardNumber", 			credit.cardNumber		);
			req.setValue("cvv", 				credit.cvv				);
			req.setValue("expiryDate",			credit.expiryDate		);
			req.setTokenize(					false					);

		// Encrypt CC data
		var session = new connectsdk.Session(sessionDetails);
		let encryptor = session.getEncryptor();

		return encryptor.encrypt(req).then( ( codes ) => {
			return codes;
		}, function( errors ) {
			if ( errors ) throw ( errors );
			return false;
		});
	
	}




	// Get the GlobalCollect Session key
	gcSession(): Promise<any> {

		let identity = this.cookie.get('id');
		let headers = new Headers({
			'Authorization': 'Bearer ' + identity,
			'Content-Type': 'application/json'
		});

		let options = new RequestOptions({ headers: headers });

		// Expects comma-seperated list
		return this.http
			.get(`${environment.baseUrl}/ingenico/client/`, options)
			.toPromise()
			.then( resp => {

				let encoded = resp.text();

				let data = JSON.parse( encoded );
				data.region = environment.globalcollect.region;				// US / EU
				data.environment = environment.globalcollect.environment;

				this.sessionKeys = data;
				return this.sessionKeys;

			}).catch((err) => { console.log(err); })
  	}




	/**
	* Get statistics
	**/

  	getSocialStatistics(): Promise<Statistic> {
		return this.http
			.get(`${environment.baseUrl}/statistics/social/`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapStatistics)
			.catch((err) => {

			})
  	}

  	getStatistics(): Promise<Statistic> {
		return this.http
			.get(`${environment.baseUrl}/statistics/`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapStatistics)
			.catch((err) => {

			})
  	}



	/**
	* Accept return API headers
	**/

  	private getHeaders() {
  		let headers = new Headers();
  		headers.append('Accept', 'application/json');
  		return headers;
  	}





} //export class StoreService



/**
* 		Managing product data
**/

function mapProduct(response:Response): Product {
	let res = response.json().item.map(toProduct);
	return res;
}

function mapProducts(response:Response): Product {
	let res = response.json().items.map(toProduct);
	return res;
}

function toProduct(r:any): Product {
	let p = <Product>({
		id: r.id,
		beta: r.beta,
		currency: r.currency,
		category: r.category,
		description: r.description,
		html: r.html,
		rich_html: r.rich_html,
		discount: r.discount,
		images: r.images,
		imagecount: r.imagecount,
		imagesizes: r.imagesizes,
		instock: r.instock,
		stock: r.stock,
		items: r.items,
		itemsCount: r.itemsCount,
		limit: r.limit,
		owns: r.owns,
		limited: r.limited,
		icon: r.icon,
		oldprice: r.oldprice,
		originalprice: r.originalprice,
		price: r.price,
		points: r.points,
		pointValues: r.pointValues,
		countPoints: r.countPoints,
		product: r.product,
		type: r.type,
		removeitems: r.removeitems,
		title: r.title,
		published: r.published,
		quantity: r.quantity
	});
	return p;
}


/**
* 		Managing item data
**/

function mapOrders(response: Response): Order {
	return response.json().order.map(toOrders);
}

function toOrders(r:any): Order {
	let storeOrder = <Order>({
		id: r.id,
		err: r.err,
		code: r.code,
		items: r.items,
		status: r.status,
		amount: r.amount,
		products: r.products
	});
	return storeOrder;
}



/**
* 		Managing item data
**/

function mapItem(response: Response): Item {
	return response.json().items.map(toItems);
}

function toItems(r:any): Item {
	let storeItem = <Item>({
		id: r.id,
		title: r.title,
		label: r.label,
		description: r.description,
		html: r.html,
		plural: r.plural,
		value: r.value,
		slug: r.slug,
		icon: r.icon,
		points: r.points,
		pointValues: r.pointValues,
		countPoints: r.countPoints,
		images: r.images,
		imagecount: r.imagecount,
		imagesizes: r.imagesizes,
		owns: r.owns,
		price: r.price,
		discount: r.discount,
		stock: r.stock,
		instock: r.instock,
		category: r.category,
		category_info: r.category_info,
		group: r.group,
		models: r.models,
		build_state: r.build_state,
		group_info: r.group_info,
		rich_html: r.rich_html,
		published: r.published,
		hidden: r.hidden,
		packaged_items: r.packaged_items,
		limit: r.limit,
		updated_by: r.updated_by,
		created: r.created,
		modified: r.modified,
		type: r.type,
		customize: r.customize,
		quantity: r.quantity
	});
	return storeItem;
}


/**
* 		Managing payment product data
**/

function mapPaymentProduct(response: Response): PaymentProduct {
	return response.json().products.json.paymentProducts.map(toPaymentProduct);
}

function toPaymentProduct(r:any): PaymentProduct {
	let paymentProduct = <PaymentProduct>({
		id: r.id,
		type: r.type,
		displayHints: r.displayHints,
		paymentMethod: r.paymentMethod,
		autoTokenized: r.autoTokenized,
		allowsRecurring: r.allowsRecurring,
		allowsTokenization: r.allowsTokenization,
		mobileIntegrationLevel: r.mobileIntegrationLevel,
		deviceFingerprintEnabled: r.deviceFingerprintEnabled
	});
	return paymentProduct;
}



/**
* 		Managing order data
**/

function mapOrder(response:Response): Order {
	let res = response.json().order.map(toOrder);
	return res;
}

function toOrder(r:any): Order{
	let order = <Order>({
		amount: r.amount,
		code: r.code,
		err: r.err,
		status: r.status
	});

	return order;
}



/**
* 		Managing product categories
**/

function mapCategories(response:Response): Category {
	let res = response.json().categories.map(toCategory);
	return res;
}

function toCategory(r:any): Category {
	let category = <Category>({
		id: r.id,
		icon: r.icon,
		value: r.value,
		name: r.name,
		label: r.label,
		published: r.published,
		description: r.description
	});
	return category;
}



/**
* 	Currencies
**/

function mapCurrencies(response:Response): Currency {
	let res = response.json().currencies.map(toCurrencies);
	return res;
}

function toCurrencies(r:any): Currency {
	let currency = <Currency>({
		id: r.id,
		default: r.default,
		symbol: r.symbol,
		value: r.value,
		name: r.name
	});
	return currency;
}




/**
* 		Managing payment methods
**/

function mapMethods(response:Response): Method {
	if (response) {
		let res = response.json().payment_options.map(toMethods);
		return res;
	}
}

function toMethods(r:any): Method {
	let methodman = <Method>({
		id: r.id,
		name: r.name,
		public_key: r.public_key,
		endpoint: r.endpoint,
		enabled: r.enabled,
		service: r.service
	});
	return methodman;
}

/**
* 		Image Mapping
**/

function mapImages(response:Response): Img {
	let res = response.json().images.map(toImage);
	return res;
}

function toImage(r:any): Img {
	let img = <Img>({
		id: r.id,
		size: r.size,
		url: r.url,
		width: r.width,
		height: r.height,
		title: r.title,
		description: r.description,
		alt: r.alt,
		tags: r.tags,
		created: r.created
	});
	return img;
}


/**
* 		Managing statistics
**/

function mapStatistics(response?:Response): Statistic {
	let res = response.json().statistics.map(toStatistics);
	return res;
}

function toStatistics(r?:any): Statistic {
	let stats = <Statistic>({
		name: r.name,
		statistic: r.statistic
	});
	return stats;
}



/**
* 		Error Handling
**/

// this could also be a private method of the component class
function handleError (error: any) {
	// log error
	// could be something more sofisticated
	let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
	console.error(errorMsg);

	// throw an application level error
	return Observable.throw(errorMsg);
}




// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/services/store.service.ts